var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTreeFold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.4714 5.13807C6.73175 4.87772 6.73175 4.45561 6.4714 4.19526C6.21105 3.93491 5.78894 3.93491 5.5286 4.19526L2.19526 7.5286C1.93491 7.78894 1.93491 8.21106 2.19526 8.4714L5.5286 11.8047C5.78894 12.0651 6.21105 12.0651 6.4714 11.8047C6.73175 11.5444 6.73175 11.1223 6.4714 10.8619L3.60948 8L6.4714 5.13807Z",
    fill: "#111111"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4714 5.13807C12.7318 4.87772 12.7318 4.45561 12.4714 4.19526C12.2111 3.93491 11.7889 3.93491 11.5286 4.19526L8.19526 7.5286C7.93491 7.78894 7.93491 8.21106 8.19526 8.4714L11.5286 11.8047C11.7889 12.0651 12.2111 12.0651 12.4714 11.8047C12.7318 11.5444 12.7318 11.1223 12.4714 10.8619L9.60948 8L12.4714 5.13807Z",
    fill: "#111111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTreeFold);
export default __webpack_public_path__ + "static/media/icon-tree-fold.d5d6da174ad57bd82db1d08d4708a2df.svg";
export { ForwardRef as ReactComponent };